import React, { useEffect, useState }from 'react';
import PropTypes from 'prop-types';
import DismissButton from './DismissButton';
import {
    INSTRUCTION_CARD_CLASS,
    CONTENT_CLASS,
    CONTENT_CONTAINER_CLASS,
    FOOTER_CLASS,
    CONTENT_ICON_CLASS,
    CONTENT_ICON,
    CONTENT_TEXT_CLASS,
    CONTENT_ICON_SWIPE,
    CONTENT_TITLE_CLASS,
    CONTENT_DETAIL_CLASS,
    BETFEED_INSTRUCTION_CARD,
    SPECIALS_INSTRUCTION_CARD,
}
from './constants/constants';

import {
    isUserLoggedIn,
    getIsMobileWrapperFlag,
    getInstructionCards,
    onInstructionCardsChange,
} from '~shared/utils/user';

import './styles/instructionCard.scss';

const InstructionCard = (props) => {
    if (!isUserLoggedIn()) {
        return null;
    }

    return <InstructionCardAuth {...props} />;
};

const InstructionCardAuth = ({
    contentText,
    footerText,
    titleText,
    gtmAttribute,
    type,
    pageMode,
}) => {
    const initialState = getInstructionCards();
    const checkCardAvailability = (instructionCards) => instructionCards.includes(type);

    const [isAvailable, setIsAvailable] = useState(checkCardAvailability(initialState));

    useEffect(() => {
        const stateSubscription = onInstructionCardsChange(
            (_, cards) => setIsAvailable(
                checkCardAvailability(cards)
            )
        );

        return () => {
            stateSubscription((unsubscribe) => unsubscribe());
        };
    }, []);

    if (!isAvailable) {
        return null;
    }

    const instructionFooter = () => (
    <div className={FOOTER_CLASS}>
        <span>
            {footerText}
        </span>
    </div>
    );

    /**
     * Need to do betfeed widget slightly differently as there are issues with the carousel component
     */
    const isSwiperWidget = (type === BETFEED_INSTRUCTION_CARD || type === SPECIALS_INSTRUCTION_CARD) && !pageMode;

    const iconClass = getIsMobileWrapperFlag() && isSwiperWidget
        ? CONTENT_ICON_SWIPE
        : CONTENT_ICON;

    const showFooter = footerText ? instructionFooter() : '';
    const showTitle = titleText ? <span className={CONTENT_TITLE_CLASS}>{titleText}</span> : '';

    return (
        <div>
            <div className={INSTRUCTION_CARD_CLASS}>
                <div className={CONTENT_CLASS}>
                    <div className={CONTENT_CONTAINER_CLASS}>
                        <div className={CONTENT_ICON_CLASS}>
                            <div className={iconClass}></div>
                        </div>
                        <div className={CONTENT_DETAIL_CLASS}>
                            {showTitle}
                            <span className={CONTENT_TEXT_CLASS}>
                                {contentText}
                            </span>
                        </div>
                    </div>
                    <DismissButton
                        gtmAttribute={gtmAttribute}
                        type={type}
                    />
                </div>
                {showFooter}
            </div>
        </div>
    );
};

InstructionCardAuth.propTypes = {
    contentText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    footerText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    titleText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
    ]),
    gtmAttribute: PropTypes.string,
    type: PropTypes.string.isRequired,
    pageMode: PropTypes.bool,
};

InstructionCardAuth.defaultProps = {
    contentText: '',
    footerText: '',
    titleText: '',
    gtmAttribute: '',
    pageMode: false,
};

export default InstructionCard;
